import type {
	GetBackgroundJobItemsQuery,
	GetBackgroundJobQuery,
	GetMyBackgroundJobsQuery
} from "~/gql/queries/backgroundJob.generated";

export const backgroundJobEndpoints = {
	CancelBackgroundJob: {
		invalidatesTags: ["BackgroundJobs"] as AddTagTypes
	},
	ClearFinishedBackgroundJobs: {
		invalidatesTags: ["BackgroundJobs"] as AddTagTypes
	},
	DismissBackgroundJob: {
		invalidatesTags: ["BackgroundJobs"] as AddTagTypes
	},
	GetBackgroundJob: {
		providesTags: ["BackgroundJobs"] as AddTagTypes,
		transformResponse: (res: GetBackgroundJobQuery) => res
	},
	GetBackgroundJobItems: {
		providesTags: ["BackgroundJobs"] as AddTagTypes,
		transformResponse: (res: GetBackgroundJobItemsQuery) => res
	},
	GetMyBackgroundJobs: {
		providesTags: ["BackgroundJobs"] as AddTagTypes,
		transformResponse: (res: GetMyBackgroundJobsQuery) => res
	},
	RetryFailedBackgroundJobItems: {
		invalidatesTags: ["BackgroundJobs"] as AddTagTypes
	}
};
